import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "emailField"]
  
  connect() {
    console.log("InviteEmails controller connected!")
  }
  
  addEmail(event) {
    event.preventDefault()
    console.log("Add email button clicked!")
    
    const template = this.emailFieldTargets[0].cloneNode(true)
    const input = template.querySelector('input')
    const removeButton = template.querySelector('button')
    
    // Clear the input value
    input.value = ""
    
    // Show the remove button
    removeButton.style.display = "inline-block"
    
    // Add to container
    this.containerTarget.appendChild(template)
    
    // Focus the new input
    input.focus()
    
    console.log("New email field added!")
  }
  
  removeEmail(event) {
    event.preventDefault()
    
    const fieldWrapper = event.target.closest('[data-invite-emails-target="emailField"]')
    
    // Don't remove if it's the last field
    if (this.emailFieldTargets.length > 1) {
      fieldWrapper.remove()
    } else {
      // Just clear the input if it's the only one
      const input = fieldWrapper.querySelector('input')
      input.value = ""
    }
  }
}
